import { Button, Checkbox, FormControlLabel, Stack } from "@mui/material";
import { ReactComponent as QuestionIcon } from "images/ask-question-icon.svg";
import { ReactComponent as ReferIcon } from "images/refer-icon.svg";
import { DialogWindow } from "../DialogWindow";
import { ButtonInfo, checkBoxSx, types } from "./ReferralForm.common";

export const ActionSelectorForm = ({
  recipientName,
  provider,
  sender,
  watch,
  setValue,
  getValues,
  isButtonEnabled,
  setStep,
  handleClose = null,
}) => {
  const type = watch("type");

  const handleSelectAction = () => {
    const { type } = getValues();
    setStep(type);
    setValue("type", type);
  };

  return (
    <DialogWindow
      title={"Choose an action"}
      handleClose={handleClose}
      withCloseButton={!!handleClose}
      content={
        <Stack direction={"column"} maxWidth={"360px"}>
          <ButtonInfo
            recipientName={recipientName}
            provider={provider}
            sender={sender}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={type === types.Referral}
                onChange={() => setValue("type", types.Referral)}
              />
            }
            label={
              <Stack
                width={"calc(80vw - 80px)"}
                maxWidth={"280px"}
                direction={"row"}
                alignItems={"center"}
                gap={1}
              >
                <ReferIcon />
                Refer
              </Stack>
            }
            sx={checkBoxSx}
          />
          <FormControlLabel
            control={
              <Checkbox
                checked={type === types.Question}
                onChange={() => setValue("type", types.Question)}
              />
            }
            label={
              <Stack direction={"row"} alignItems={"center"} gap={1}>
                <QuestionIcon />
                Ask a Question
              </Stack>
            }
            sx={checkBoxSx}
          />
        </Stack>
      }
      actions={
        <Stack
          flex={1}
          direction={"row"}
          gap={1}
          justifyContent={"center"}
          alignItems={"center"}
        >
          <Button
            variant="contained"
            color="primary"
            disabled={!isButtonEnabled}
            onClick={handleSelectAction}
          >
            Continue
          </Button>
        </Stack>
      }
    />
  );
};
